import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import toast from 'react-hot-toast';
import { Eye, EyeOff, Music, Check } from 'lucide-react';

export default function RegisterPage() {
  const [form, setForm] = useState({ first_name: '', last_name: '', email: '', password: '', confirm_password: '', tc_accepted: false });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm_password) return toast.error('Le password non corrispondono');
    if (form.password.length < 8) return toast.error('La password deve avere almeno 8 caratteri');
    if (!form.tc_accepted) return toast.error('Devi accettare i Termini e Condizioni');
    setLoading(true);
    try {
      await register(form);
      toast.success('Registrazione completata! Controlla la tua email.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Errore durante la registrazione');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#1A1A2E] flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#E94560] mb-3">
            <Music size={28} className="text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white">PROUD NOIZE</h1>
          <p className="text-gray-400 text-sm mt-1">Crea il tuo account</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-xl p-7">
          <div className="grid grid-cols-2 gap-3 mb-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Nome</label>
              <input value={form.first_name} onChange={e => set('first_name', e.target.value)} required className="input-field" placeholder="Mario" />
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1">Cognome</label>
              <input value={form.last_name} onChange={e => set('last_name', e.target.value)} required className="input-field" placeholder="Rossi" />
            </div>
          </div>

          <div className="mb-4">
            <label className="block text-xs font-medium text-gray-600 mb-1">Email</label>
            <input type="email" value={form.email} onChange={e => set('email', e.target.value)} required className="input-field" placeholder="la-tua@email.com" />
          </div>

          <div className="mb-4">
            <label className="block text-xs font-medium text-gray-600 mb-1">Password</label>
            <div className="relative">
              <input type={showPw ? 'text' : 'password'} value={form.password} onChange={e => set('password', e.target.value)} required className="input-field pr-12" placeholder="Minimo 8 caratteri" />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400">
                {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <div className="mb-5">
            <label className="block text-xs font-medium text-gray-600 mb-1">Conferma Password</label>
            <input type="password" value={form.confirm_password} onChange={e => set('confirm_password', e.target.value)} required className="input-field" placeholder="Ripeti la password" />
          </div>

          <label className="flex items-start gap-3 mb-6 cursor-pointer">
            <div className={`w-5 h-5 rounded border-2 flex-shrink-0 flex items-center justify-center mt-0.5 transition ${form.tc_accepted ? 'bg-[#E94560] border-[#E94560]' : 'border-gray-300'}`}
              onClick={() => set('tc_accepted', !form.tc_accepted)}>
              {form.tc_accepted && <Check size={12} className="text-white" />}
            </div>
            <span className="text-xs text-gray-600">
              Accetto i <Link to="/legal/terms" target="_blank" className="text-[#E94560] underline">Termini e Condizioni</Link> e l'<Link to="/legal/privacy" target="_blank" className="text-[#E94560] underline">Informativa sulla Privacy</Link>
            </span>
          </label>

          <button type="submit" disabled={loading} className="w-full btn-primary py-3">
            {loading ? 'Registrazione...' : 'Crea Account'}
          </button>

          <p className="text-center text-sm text-gray-500 mt-5">
            Hai già un account? <Link to="/login" className="text-[#E94560] font-medium hover:underline">Accedi</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
